import React, { ReactNode, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./styles/horizontalScroll.scss";

interface HorizontalScrollProps {
  children: ReactNode;
}

const HorizontalScroll: React.FC<HorizontalScrollProps> = ({ children }) => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollContainerRef.current) {
        const { scrollLeft } = scrollContainerRef.current;
        const cards =
          scrollContainerRef.current.querySelectorAll<HTMLDivElement>(
            ".team-member-card"
          );
        cards.forEach((card) => {
          // Parallax effect
          const offset = scrollLeft * 0.2;
          card.style.setProperty("transform", `translateX(${offset}px)`);
        });
      }
    };

    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const scrollBy = (distance: number) => {
    scrollContainerRef.current?.scrollBy({
      left: distance,
      behavior: "smooth"
    });
  };

  return (
    <div className="horizontal-scroll-wrapper">
      <button className="scroll-arrow left" onClick={() => scrollBy(-200)}>
        <ChevronLeft />
      </button>
      <div className="horizontal-scroll-container" ref={scrollContainerRef}>
        <div className="horizontal-scroll-content">{children}</div>
      </div>
      <button className="scroll-arrow right" onClick={() => scrollBy(200)}>
        <ChevronRight />
      </button>
    </div>
  );
};

export default HorizontalScroll;
